import React from 'react';
import { useInView } from 'react-intersection-observer'; // Import useInView
import styles from './LogoMarquee.module.css';

// Logos for the first row
const logosRow1_data = [
  "https://res.cloudinary.com/ddkyeuhk8/image/upload/v1747470580/Digisavvy/REAL%20ESTATE%20CLIENTSLOGOS/mnld4lkrapxhqjrp0b4s.png",
  "https://res.cloudinary.com/ddkyeuhk8/image/upload/v1747470580/Digisavvy/REAL%20ESTATE%20CLIENTSLOGOS/crcoqphljkmx1o4xahxg.png",
  "https://res.cloudinary.com/ddkyeuhk8/image/upload/v1747470579/Digisavvy/REAL%20ESTATE%20CLIENTSLOGOS/k48p8ebiwlurnfnwohsi.png",
  "https://res.cloudinary.com/ddkyeuhk8/image/upload/v1747470579/Digisavvy/REAL%20ESTATE%20CLIENTSLOGOS/txzkhiqckxvf1ox3kayu.png",
  "https://res.cloudinary.com/ddkyeuhk8/image/upload/v1747470577/Digisavvy/REAL%20ESTATE%20CLIENTSLOGOS/d8yui5mu2aab1vwq3gnp.png",
  "https://res.cloudinary.com/ddkyeuhk8/image/upload/v1747470577/Digisavvy/REAL%20ESTATE%20CLIENTSLOGOS/ysytws6si1eukrqklvyq.png",
  "https://res.cloudinary.com/ddkyeuhk8/image/upload/v1747470577/Digisavvy/REAL%20ESTATE%20CLIENTSLOGOS/fxe2cr1haqsbgrog3v88.png",
  "https://res.cloudinary.com/ddkyeuhk8/image/upload/v1747470576/Digisavvy/REAL%20ESTATE%20CLIENTSLOGOS/il5mbvcholynfmuepqvx.png",
  "https://res.cloudinary.com/ddkyeuhk8/image/upload/v1747470576/Digisavvy/REAL%20ESTATE%20CLIENTSLOGOS/dxsxmetflyg5ovzdl5jt.png",
  "https://res.cloudinary.com/ddkyeuhk8/image/upload/v1747470576/Digisavvy/REAL%20ESTATE%20CLIENTSLOGOS/ftjoglvbxzge5itg9a0g.png",
  "https://res.cloudinary.com/ddkyeuhk8/image/upload/v1747470576/Digisavvy/REAL%20ESTATE%20CLIENTSLOGOS/imabj7tv92r0krnqyez6.png",
  "https://res.cloudinary.com/ddkyeuhk8/image/upload/v1747470575/Digisavvy/REAL%20ESTATE%20CLIENTSLOGOS/bzwicrakh33tehvrmbsi.png",
  "https://res.cloudinary.com/ddkyeuhk8/image/upload/v1747470575/Digisavvy/REAL%20ESTATE%20CLIENTSLOGOS/rkj17pd9n2vhmuysp58z.png",
  "https://res.cloudinary.com/ddkyeuhk8/image/upload/v1747470575/Digisavvy/REAL%20ESTATE%20CLIENTSLOGOS/f5vzoo2gs3fgd6hlkjp4.png",
  "https://res.cloudinary.com/ddkyeuhk8/image/upload/v1747470565/Digisavvy/BUILDERS%20LOGOS/qthghu942tlauiymegji.png",
  "https://res.cloudinary.com/ddkyeuhk8/image/upload/v1747470564/Digisavvy/BUILDERS%20LOGOS/pv1spqeptdqwei5ecu69.png",
  "https://res.cloudinary.com/ddkyeuhk8/image/upload/v1747470564/Digisavvy/BUILDERS%20LOGOS/jbxaj2gbooge9lvvllxo.png",
  "https://res.cloudinary.com/ddkyeuhk8/image/upload/v1747470564/Digisavvy/BUILDERS%20LOGOS/jghriejveqnijdj7wmpb.png",
  "https://res.cloudinary.com/ddkyeuhk8/image/upload/v1747470564/Digisavvy/BUILDERS%20LOGOS/w0bamd7prwbecb8dzg3e.png",
  "https://res.cloudinary.com/ddkyeuhk8/image/upload/v1747470564/Digisavvy/BUILDERS%20LOGOS/ruil4f9lvu4rrruyaupx.png",
  "https://res.cloudinary.com/ddkyeuhk8/image/upload/v1747470564/Digisavvy/BUILDERS%20LOGOS/dgjnfjokmt1dtimnpn3b.png",
  "https://res.cloudinary.com/ddkyeuhk8/image/upload/v1747470563/Digisavvy/BUILDERS%20LOGOS/g8rb2grz1goldvzajrje.png",
  "https://res.cloudinary.com/ddkyeuhk8/image/upload/v1747470563/Digisavvy/BUILDERS%20LOGOS/wjpsg7tngjcsgjp1kd34.png",
  "https://res.cloudinary.com/ddkyeuhk8/image/upload/v1747470563/Digisavvy/BUILDERS%20LOGOS/xdubloqdhv0gistklqyv.png",
  "https://res.cloudinary.com/ddkyeuhk8/image/upload/v1747470563/Digisavvy/BUILDERS%20LOGOS/lhty6hrjrxfpgrehqaut.png",
  "https://res.cloudinary.com/ddkyeuhk8/image/upload/v1747470563/Digisavvy/BUILDERS%20LOGOS/ymsxece7cgimcoexpkux.png",
  "https://res.cloudinary.com/ddkyeuhk8/image/upload/v1747470563/Digisavvy/BUILDERS%20LOGOS/nfo0owbbisvhq6dkbiy7.png",
];

// Logos for the second row
const logosRow2_data = [
  "https://res.cloudinary.com/ddkyeuhk8/image/upload/v1747470573/Digisavvy/Other%20Brands%20LOGOS/bje9clswhlt4fimttids.png",
  "https://res.cloudinary.com/ddkyeuhk8/image/upload/v1747470573/Digisavvy/Other%20Brands%20LOGOS/myahmvb90gcrfqm53ize.png",
  "https://res.cloudinary.com/ddkyeuhk8/image/upload/v1747470573/Digisavvy/Other%20Brands%20LOGOS/bhpmxsqmkmkatvtxpopn.png",
  "https://res.cloudinary.com/ddkyeuhk8/image/upload/v1747470573/Digisavvy/Other%20Brands%20LOGOS/sms36kqwgwgztlk8r45m.png",
  "https://res.cloudinary.com/ddkyeuhk8/image/upload/v1747470573/Digisavvy/Other%20Brands%20LOGOS/dubonjsn6orhgk3cesgv.png",
  "https://res.cloudinary.com/ddkyeuhk8/image/upload/v1747470572/Digisavvy/Other%20Brands%20LOGOS/hlvhimwn2giqplcvsw2t.png",
  "https://res.cloudinary.com/ddkyeuhk8/image/upload/v1747470572/Digisavvy/Other%20Brands%20LOGOS/qd3imxg3ekqmxsxli1ju.png",
  "https://res.cloudinary.com/ddkyeuhk8/image/upload/v1747470572/Digisavvy/Other%20Brands%20LOGOS/bflfyshzbyfdf7kqjkre.png",
  "https://res.cloudinary.com/ddkyeuhk8/image/upload/v1747470572/Digisavvy/Other%20Brands%20LOGOS/s23awnpfkcqyjzo4irtn.png",
  "https://res.cloudinary.com/ddkyeuhk8/image/upload/v1747470572/Digisavvy/Other%20Brands%20LOGOS/uffluoanefxxj6nxpw7t.png",
  "https://res.cloudinary.com/ddkyeuhk8/image/upload/v1747470566/Digisavvy/Other%20Brands%20LOGOS/hof9ylxysfgeeixyvw8w.png",
  "https://res.cloudinary.com/ddkyeuhk8/image/upload/v1747470565/Digisavvy/Other%20Brands%20LOGOS/oyu0ogfepsgbycdingpr.png",
  "https://res.cloudinary.com/ddkyeuhk8/image/upload/v1747470565/Digisavvy/Other%20Brands%20LOGOS/iayurgxz6rpbsji9jwwt.png",
  "https://res.cloudinary.com/ddkyeuhk8/image/upload/v1747470565/Digisavvy/Other%20Brands%20LOGOS/djpmvz9elthxk5ysn0gu.png",
  "https://res.cloudinary.com/ddkyeuhk8/image/upload/v1747470565/Digisavvy/Other%20Brands%20LOGOS/cm6eawvuizwql2qhcxwf.png",
  "https://res.cloudinary.com/ddkyeuhk8/image/upload/v1747470565/Digisavvy/Other%20Brands%20LOGOS/ubcydeh1swxxamjch0m2.png",
  "https://res.cloudinary.com/ddkyeuhk8/image/upload/v1747470565/Digisavvy/Other%20Brands%20LOGOS/awnrooxxjdfchwlcfssn.png",
];

// Ensure unique logos for each row
const logosRow1 = [...new Set(logosRow1_data)];
const logosRow2 = [...new Set(logosRow2_data)];


// This component renders one row of the marquee.
const AnimatedRowContent = ({ logos, directionClass }) => (
  <div className={styles[directionClass]}>
    {logos.map((url, index) => (
      <div key={`logo-${index}-original`} className={styles.logoItem}>
        <img src={url} alt={`Client Logo ${index + 1}`} className={styles.logoImage} />
      </div>
    ))}
    {logos.map((url, index) => (
      <div key={`logo-${index}-duplicate`} className={styles.logoItem}>
        <img src={url} alt={`Client Logo ${index + 1} duplicate`} className={styles.logoImage} />
      </div>
    ))}
  </div>
);

// Helper component to wrap elements that should animate on scroll
const AnimateInViewWrapper = ({ children, delaySeconds = 0, threshold = 0.1, triggerOnce = true }) => {
  const { ref, inView } = useInView({
    threshold: threshold,
    triggerOnce: triggerOnce, // Animation triggers once when element comes into view
  });

  return (
    <div
      ref={ref}
      className={`${styles.animateOnScroll} ${inView ? styles.visible : ''}`}
      style={{ transitionDelay: `${delaySeconds}s` }} // Apply delay directly
    >
      {children}
    </div>
  );
};


function LogoMarquee() {
  return (
    <section className={styles.logoMarqueeSection}>
      <div className={styles.contentHub}>
        <div className={styles.textContainer}>
          <AnimateInViewWrapper delaySeconds={0.1}>
            <h3 className={styles.hashtagTitle}>#रोटी कपड़ा और मकान</h3>
          </AnimateInViewWrapper>

          <AnimateInViewWrapper delaySeconds={0.2}>
            <h1 className={styles.mainTitle}>The Buzz Brands</h1>
          </AnimateInViewWrapper>

          <AnimateInViewWrapper delaySeconds={0.3}>
            <p className={styles.subtitle}>
              Businesses that started as clients and ended up becoming our best applauders
            </p>
          </AnimateInViewWrapper>
        </div>

        <AnimateInViewWrapper delaySeconds={0.4}>
          <div className={styles.marqueeArea}> {/* This div gets animated */}
            {/* Row 1: Scrolls Left to Right */}
            <div className={styles.marqueeRow}>
              <AnimatedRowContent logos={logosRow1} directionClass="marqueeContentLeftToRight" />
            </div>

            {/* Row 2: Scrolls Right to Left */}
            <div className={styles.marqueeRow}>
              <AnimatedRowContent logos={logosRow2} directionClass="marqueeContentRightToLeft" />
            </div>
          </div>
        </AnimateInViewWrapper>
      </div>
      <p style={{marginTop:"20px"}}>For some brands, we manage marketing and promotions via their associates, not directly with the brands.</p>
      
    </section>
  );
}

export default LogoMarquee;